import script from "./FamilyGroupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyGroupList.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyGroupList.vue?vue&type=style&index=0&id=c2f79986&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2f79986"]])

export default __exports__